import { forwardRef, type Ref, type SVGProps } from "react";
const IconLaptopFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M19 21a1 1 0 0 0-.89.55l-.5 1a.81.81 0 0 1-.74.46h-1.74a.81.81 0 0 1-.74-.46l-.5-1A1 1 0 0 0 13 21H3a1 1 0 0 0-.77.37 1 1 0 0 0-.23.83l.38 1.8a5 5 0 0 0 4.9 4h17.44a5 5 0 0 0 4.9-4l.38-1.8a1 1 0 0 0-.21-.83A1 1 0 0 0 29 21zM18 9a1 1 0 0 1-1 1h-2a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1" />
    <path d="M6 8a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v13h2V8a3 3 0 0 0-3-3H7a3 3 0 0 0-3 3v13h2z" />
  </svg>
);
const ForwardRef = forwardRef(IconLaptopFilledSVG);
ForwardRef.displayName = "IconLaptopFilled";
export { ForwardRef as IconLaptopFilled };
